import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgProcessing(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M20 12a8 8 0 01-14.583 4.547l-.157-.235-.157-.26-.06-.1a5.95 5.95 0 01-.17-.315l-.03-.056a8.051 8.051 0 01-.442-1.074L6.3 13.88a6 6 0 108.165-7.352l-.234-.1.644-1.896A8.004 8.004 0 0120 12zM5.154 16.14l.106.172-.03-.048-.076-.123zm.859-3.734l-1.995.132a8.12 8.12 0 01.118-2.017l1.966.368a6.03 6.03 0 00-.09 1.517zm.81 2.631l.083.133-.1-.165.018.032zm-.267-5.565L4.743 8.63a8.016 8.016 0 011.064-1.694l1.547 1.267a5.978 5.978 0 00-.798 1.27zm3.217-3.045c-.466.186-.906.43-1.31.727L7.28 5.54a8.035 8.035 0 011.749-.97l.744 1.857zM12.99 4.06l-.244 1.986a6.144 6.144 0 00-1.515.003l-.254-1.984a8.12 8.12 0 012.013-.005z"
      />
    </svg>
  );
}

export default tombacIcon('Processing')(SvgProcessing);
